import React from 'react';
import SportSection from './SportSection';
import { UPCOMING } from '../../data/homeData';

export default function UpcomingEvents() {
  return (
    <>
      <div className="card">
        <div className="card-body card-content p-0">
          <div className="bet-table-header green-title">
            <span className="list-sport-title">
              <i className="bi bi-calendar-event" style={{ marginRight: 6 }} /> Upcoming Events
            </span>
          </div>
        </div>
      </div>
      <SportSection section={UPCOMING} green />
    </>
  );
}
